
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import { useEffect } from '@storybook/client-api';
// The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we
// are okay with the following Webpack-specific raw loader syntax. It's better
// to leave the ESLint rule enabled globally, and only thoughtfully disable as
// needed (e.g. within a Storybook docs page and not within an actual
// component). This can be revisited in the future if Storybook no longer relies
// on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import exampleDemoSource from '!!raw-loader!./demo/example.twig';
import exampleDemo from './demo/example.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import exampleDemoWithAlertSource from '!!raw-loader!./demo/example-with-alert.twig';
import exampleDemoWithAlert from './demo/example-with-alert.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Page" parameters={{
      docs: {
        inlineStories: false
      },
      layout: 'fullscreen'
    }} decorators={[story => {
      useEffect(() => {
        // Set this story's `body` element to full-height
        document.body.style.height = '100%';
        // Prevent Storybook's container from affecting this layout
        document.querySelector('#root').style.display = 'contents';
      });
      return story();
    }]} mdxType="Meta" />
    <h1>{`Page`}</h1>
    <p>{`A wrapper for page body and footer content that keeps the footer at the bottom of the viewport even if the page is too short to push it down.`}</p>
    <p>{`For this to work correctly, each parent element needs to fill its container height. For best results, apply this to the `}<inlineCode parentName="p">{`body`}</inlineCode>{` element directly or nested immediately within.`}</p>
    <p>{`The header block is optional.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Example" height="400px" parameters={{
        layout: 'fullscreen',
        docs: {
          source: {
            code: exampleDemoSource
          }
        }
      }} mdxType="Story">
    {exampleDemo()}
  </Story>
    </Canvas>
    <h2>{`Page with Alert`}</h2>
    <p>{`The Page object also has an optional `}<inlineCode parentName="p">{`alert`}</inlineCode>{` block that can be used to pass an `}<a parentName="p" {...{
        "href": "/?path=/docs/components-alert--basic"
      }}>{`Alert component`}</a>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Example with Alert" height="400px" parameters={{
        layout: 'fullscreen',
        docs: {
          source: {
            code: exampleDemoWithAlertSource
          }
        }
      }} mdxType="Story">
    {exampleDemoWithAlert()}
  </Story>
    </Canvas>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const example = () => (
          exampleDemo()
        );
example.storyName = 'Example';
example.parameters = { storySource: { source: 'exampleDemo()' }, ...{
  layout: 'fullscreen',
  docs: {
    source: {
      code: exampleDemoSource
    }
  }
} };

export const exampleWithAlert = () => (
          exampleDemoWithAlert()
        );
exampleWithAlert.storyName = 'Example with Alert';
exampleWithAlert.parameters = { storySource: { source: 'exampleDemoWithAlert()' }, ...{
  layout: 'fullscreen',
  docs: {
    source: {
      code: exampleDemoWithAlertSource
    }
  }
} };

const componentMeta = { title: 'Objects/Page', parameters: {
  docs: {
    inlineStories: false
  },
  layout: 'fullscreen'
}, decorators: [story => {
  useEffect(() => {
    // Set this story's `body` element to full-height
    document.body.style.height = '100%';
    // Prevent Storybook's container from affecting this layout
    document.querySelector('#root').style.display = 'contents';
  });
  return story();
}], includeStories: ["example","exampleWithAlert"],  };

const mdxStoryNameToKey = {"Example":"example","Example with Alert":"exampleWithAlert"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;